import { useEffect, useRef, useState } from "react";
import supportDocument from "../support-widget.html?raw";

// Mounted only by MarketingLanding, after auth restoration confirms signed out.
// Removing the frame also destroys the external widget's timers and listeners.
export function PublicSupportChat() {
  const frame = useRef<HTMLIFrameElement>(null);
  const [open, setOpen] = useState(false);
  const [installed, setInstalled] = useState(() =>
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );

  useEffect(() => {
    const mode = window.matchMedia("(display-mode: standalone)");
    const update = () => setInstalled(mode.matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true);
    mode.addEventListener("change", update);
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return;
      if (event.data?.type === "famdashfun-support-state" && typeof event.data.open === "boolean") {
        setOpen(event.data.open);
      }
    };
    window.addEventListener("message", onMessage);
    return () => {
      mode.removeEventListener("change", update);
      window.removeEventListener("message", onMessage);
    };
  }, []);

  if (installed) return null;
  return <iframe
    ref={frame}
    srcDoc={supportDocument}
    title="FamDashFun support chat"
    style={{ position: "fixed", right: 0, bottom: 0, border: 0,
      width: open ? "min(430px, 100vw)" : "min(260px, 100vw)",
      height: open ? "min(740px, 100dvh)" : "104px",
      zIndex: 1000, background: "transparent", colorScheme: "normal" }}
  />;
}
